var exports = {
  "PC": "x936d19a0--0ebae3--textarea",
  "Gq": "x936d19a0--0ebae3--invalid",
};

module.exports = exports;
